// Diwali Theme Configuration
export const diwaliTheme = {
  id: 'diwali',
  name: 'Diwali',
  colors: {
    primary: '#FF6B35',
    secondary: '#FFD700',
    accent: '#E63946'
  },
  confetti: {
    enabled: true,
    colors: ['#FF6B35', '#FFD700', '#E63946', '#F77F00'],
    count: 80,
    shapes: ['diya']
  },
  fireworks: {
    enabled: true,
    interval: 2500,
    style: 'sparkler'
  },
  banner: {
    enabled: true,
    text: '🪔 Happy Diwali! शुभ दीपावली 🪔',
    backgroundColor: 'linear-gradient(135deg, #FF6B35 0%, #F77F00 100%)'
  },
  particles: {
    diyas: true,
    sparkles: true
  }
};
